<div class="holder-holder">
  <div class="holder" [class.closed]="false">
    @switch (activeComponent) {
      @case (entities.Flyer) {
        <binsta-new-flyer
          [@fadeInOnEnter]
          [@fadeOutOnLeave]
          (close)="closeHolder()"
        ></binsta-new-flyer>
      }
      @case (entities.Image) {
        <binsta-new-image
          [@fadeInOnEnter]
          [@fadeOutOnLeave]
          (close)="closeHolder()"
        ></binsta-new-image>
      }
      @default {
        <button (click)="open(entities.Flyer)" class="btn btn-link text-dark">
          New flyer
        </button>
        <button (click)="open(entities.Image)" class="btn btn-link text-dark">
          New image
        </button>
      }
    }
  </div>
</div>
